import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { RouterModule } from '@angular/router';
import { QueryList } from '../../providers/query-list';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.css']
})
export class DepositComponent implements OnInit {

  cashAcctList = [];
  bankAcctList = [];
  avail_amount = 0;
  available_amount;
  deposit_attach: File = null;
  deposit_auth = true;

  model = {
    'table_name': 'deposit', 'deposit_id': '0', 'deposit_no': '', 'from_acct': '0', 'deposit_amount': '',
    'flag': 'new', 'key': 'deposit_id', 'to_acct': '0', 'deposit_date': '', 'deposit_attach': '', 'comment': '',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'no':'0'
  };

  date_model = { 'deposit_date': new Date() };

  cash_detail = '';
  bank_detail = '';

  Success_Msg; Error_Msg; Dep_Amount_Msg; Avail_Amount_Msg; Dep_Bank_Msg;
  File_Size_Msg; File_Type_Msg; Dep_No_Msg; Del_File_Msg; Casher_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants, private queryList: QueryList,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    private dialogRef: MatDialogRef<DepositComponent>, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Dep_Amount_Msg').subscribe((res: string) => {
      this.Dep_Amount_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Avail_Amount_Msg').subscribe((res: string) => {
      this.Avail_Amount_Msg = res;
    });

    translate.get('Dep_Bank_Msg').subscribe((res: string) => {
      this.Dep_Bank_Msg = res;
    });

    translate.get('File_Size_Msg').subscribe((res: string) => {
      this.File_Size_Msg = res;
    });

    translate.get('File_Type_Msg').subscribe((res: string) => {
      this.File_Type_Msg = res;
    });

    translate.get('Dep_No_Msg').subscribe((res: string) => {
      this.Dep_No_Msg = res;
    });

    translate.get('Del_File_Msg').subscribe((res: string) => {
      this.Del_File_Msg = res;
    });

    translate.get('Casher_Msg').subscribe((res: string) => {
      this.Casher_Msg = res;
    });

  }

  ngOnInit() {
    this.avail_amount = 0;
    this.available_amount = 0;

    let obj, query;

    // get leaf cashier accts
    let parent_acct = this.applicationConstants.main_acct_config['cash'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cashAcctList = data.data['list'];

        // if (!this.deposit_auth && this.applicationConstants.user_info['is_counter'] == '0') {
        //   (document.getElementById('from_acct') as HTMLInputElement).disabled = true;
        //   this.model['from_acct'] = this.applicationConstants.user_info.casher_acct_number;
        //   this.changeAcct();
        // }
      });

    // get leaf bank accts
    parent_acct = this.applicationConstants.main_acct_config['bank'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.bankAcctList = data.data['list'];
      });

    ///////////////////////// EDIT /////////////////////////

    if (this.dialog_data != null) {
      this.model = this.dialog_data;
      console.log(this.model['from_acct']);
      console.log(this.model['to_acct']);
      // get cash detail
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['from_acct'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          
          if (data.data['list'].length > 0) {
            let sub_acct = data.data['list'][0];
            // console.log(sub_acct);
            // (document.getElementById('search_value_1') as HTMLInputElement).value = sub_acct['acct_number'] + " - " + sub_acct['sub_acct_name'] + " - " + 
            // sub_acct['sub_acct_name_en'];
            this.cash_detail = sub_acct['acct_number'] + " - " + sub_acct['sub_acct_name'] + " - " + 
              sub_acct['sub_acct_name_en'];
            console.log(this.cash_detail);
          }
        });

      // get bank detail
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['to_acct'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            let sub_acct = data.data['list'][0];
            // console.log(sub_acct);
            this.bank_detail = sub_acct['acct_number'] + " - " + sub_acct['sub_acct_name'] + " - " + 
              sub_acct['sub_acct_name_en'];
          }
        });

      this.date_model['deposit_date'] = new Date(this.model['deposit_date']);
      (document.getElementById('deposit_attach') as HTMLInputElement).disabled = (this.model['deposit_attach'] != '');
      this.changeAcct();
    }
  }

  changeAcct() {
    let obj = { cmd: 'getAcctBalance', acct_number: this.model['from_acct'], acct_type: 'acct' };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.avail_amount = Number(data.status['msg']);
        // console.log(this.avail_amount);
        if (this.model['flag'] == 'update')
          this.available_amount = (this.avail_amount + Number(this.model['deposit_amount'])).toFixed(2);
        else
          this.available_amount = this.utils.numberFormat(data.status['msg']);
      });
  }

  onChangeCashSearch = function (acct_number: string) {
    console.log(acct_number);
    this.model['from_acct'] = acct_number; // search_result['no'];
    if (this.model['from_acct'] != '')
      this.changeAcct();

    //this.model['acct_name'] = (document.getElementById('search_value_10000') as HTMLInputElement).value;
    // this.model['account_type'] = 'cashier';
  }

  onChangeBankSearch = function (acct_number: string) {
    this.model['to_acct'] = acct_number; 
    // this.model['to_acct'] = acct_number; // search_result['no'];
    //this.model['acct_name'] = (document.getElementById('search_value_20000') as HTMLInputElement).value;
    // this.model['account_type'] = 'bank';
  }

  fileSelected(event) {
    this.deposit_attach = <File>event.target.files[0];
  }

  add() {
    // console.log(this.deposit_attach);
    console.log(this.model['from_acct']);
    if (this.model['from_acct'] == '0' || this.model['from_acct'] == '') {
      alert(this.Casher_Msg);
      (document.getElementById("search_value_1") as HTMLInputElement).focus();
      return;
    }
    
    if (this.model['deposit_amount'] == '') {
      alert(this.Dep_Amount_Msg);
      (document.getElementById("deposit_amount") as HTMLInputElement).focus();
      return;
    }
    
    if (this.available_amount < Number(this.model['deposit_amount'])) {
      alert(this.Avail_Amount_Msg);
      (document.getElementById("deposit_amount") as HTMLInputElement).focus();
      return;
    }

    if (this.model['to_acct'] == '0' || this.model['to_acct'] == '') {
      alert(this.Dep_Bank_Msg);
      (document.getElementById("search_value_2") as HTMLInputElement).focus();
      return;
    }

    if (this.deposit_attach != null && this.deposit_attach.size > 5000000) {
      alert(this.File_Size_Msg);
      (document.getElementById("deposit_attach") as HTMLInputElement).focus();
      return;
    }

    if (this.deposit_attach != null && this.deposit_attach.type != "image/png" && this.deposit_attach.type != "image/jpeg" &&
      this.deposit_attach.type != "image/gif" && this.deposit_attach.type != "application/pdf") {
      alert(this.File_Type_Msg);
      (document.getElementById("deposit_attach") as HTMLInputElement).focus();
      return;
    }

    this.model['deposit_date'] = (this.date_model['deposit_date'].getFullYear() + "-" +
      (this.date_model['deposit_date'].getMonth() + 1) + "-" + this.date_model['deposit_date'].getDate() + ' ' +
      (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds());

    // if(this.deposit_attach != null)
    //   this.model['deposit_attach'] = this.file.name;

    let values = [];
    let obj;
    values.push(this.model);

    if (this.model['deposit_id'] == '0' || this.model['flag'] == 'new') {
      let year = this.date_model['deposit_date'].getFullYear();
      this.model['year'] = year;

      let prefix = this.model['branch_id'] + "-" + year + "-";
      let idWhere = " WHERE `year` = '" + year + "'";

      obj = { cmd: 'add', values: values, pk: 'deposit_no', id: 'no', main_table: 'deposit', 
        prefix: prefix, idWhere: idWhere };
    }
    else
      obj = { cmd: 'updateAdv', values: values };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          if (this.model['deposit_id'] == '0')
            this.model['deposit_no'] = data.status['msg'][0]['number'];

          if (this.deposit_attach != null) {
            if (this.model['deposit_id'] == '0')
              this.uploadDepositeFile(data.status['msg'][0]['id']);
            else
              this.uploadDepositeFile(this.model['deposit_id']);
          }
          else {
            alert(this.Success_Msg + this.Dep_No_Msg + this.model['deposit_no']);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
        }
        else {
          alert(this.Error_Msg);
        }
      });
  }

  uploadDepositeFile(deposit_id) {
    let file_extention, file_name, obj;

    file_extention = (this.deposit_attach.name).substring((this.deposit_attach.name).lastIndexOf('.'));
    file_name = 'deposite_' + this.model['deposit_no'] + file_extention;
    obj = {
      file_name: file_name, cmd: 'update',
      values: [{ 'table_name': this.model['table_name'], 'deposit_attach': file_name }],
      where: [{ 'deposit_id': deposit_id }]
    };

    this.utils.uploadFile(this.applicationConstants.uploadFile, this.deposit_attach, obj)
      .subscribe(data => {

        if (data.status['type'] == 'success') {
          alert(this.Success_Msg + this.Dep_No_Msg + this.model['deposit_no']);
          this.dialog_data = { 'op_type': 'success' };
          this.dialogRef.close(this.dialog_data);
        }
        else
          alert(data.status['msg']);
      });
  }

  deleteAttach(event) {
    if (confirm(this.Del_File_Msg)) {
      let obj;
      //if (event.target.id == "del_deposit_attach") {
      obj = {
        file_name: this.model['deposit_attach'], cmd: 'remove',
        values: [{ 'table_name': this.model['table_name'], 'deposit_attach': '' }],
        where: [{ 'deposit_id': this.model['deposit_id'] }]
      };
      //}

      this.utils.uploadFile(this.applicationConstants.uploadFile, null, obj)
        .subscribe(data => {
          // console.log(data);
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.model['deposit_attach'] = '';
            (document.getElementById('deposit_attach') as HTMLInputElement).disabled = false;
          }
          else
            alert(data.status['msg']);
        });
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
